export default __webpack_public_path__ + "static/media/misc-books4-1024w.22e52c95.avif";